;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .directive('csVulnerabilityBugtracker', csVulnerabilityBugtracker)

  function csVulnerabilityBugtracker() {
    return {
      restrict: 'E',
      controller: 'csVulnerabilityBugtrackerCtrl',
      controllerAs: 'csVulnBugtrackerCtrl',
      scope: {
        bugtrackers: '=',
        status: '=',
        placement: '='
      },
      bindToController: true,
      templateUrl: 'components/vulnerabilities/cs-vuln-bugtracker.html',
      link: function (scope, elem, attrs, ctrl) {
        elem.addClass(ctrl.getStyle(ctrl.status))

        scope.$watch(
          function () {
            return ctrl.status
          },
          function (newVal, oldVal) {
            if (newVal != oldVal) {
              elem.removeClass(ctrl.getStyle(oldVal))
              elem.addClass(ctrl.getStyle(newVal))
            }
          }
        )
      }
    }
  }
})()
